export default __webpack_public_path__ + "static/media/banner2.2dad1238.jpg";